import $ from 'jquery';

$(function() {
    // Video play button
    $('.video-header, .video-container').each(function (index, element) {
        const btnPlayVideo = $('.btn-video-play', element);
        const theVideo = $('video', element)[0];
        btnPlayVideo.on('click', () => {
            if (theVideo.paused) {
                theVideo.play();
                $(element).addClass('is-playing');
                theVideo.setAttribute('controls', 'controls');
            }
        });
    });
});

function initVideos() {
    // Get all YouTube videos iframes
    const youtubeVideos = $('body').find('iframe[src*="youtube.com"]');
    if (youtubeVideos.length > 0) {
        // For each YouTube video
        youtubeVideos.each(function () {
            const $this = $(this);
            let src = $this.attr('src');
            // Enabled JS API if not enabled
            if (src.indexOf('enablejsapi=1') === -1) {
                if (src.indexOf('?') === -1) {
                    src += '?enablejsapi=1';
                } else {
                    src += '&enablejsapi=1';
                }
                $this.attr('src', src);
            }
        });
    }

    // Get all Vimeo videos iframes
    const vimeoVideos = $('body').find('iframe[src*="vimeo.com"]');
    if (vimeoVideos.length > 0) {
        // For each YouTube video
        vimeoVideos.each(function () {
            const $this = $(this);
            let src = $this.attr('src');
            // Enabled JS API if not enabled
            if (src.indexOf('api=1') === -1) {
                if (src.indexOf('?') === -1) {
                    src += '?api=1';
                } else {
                    src += '&api=1';
                }
                $this.attr('src', src);
            }
        });
    }
}

$('.media-container.has-video').each(function () {
    $(this).find('button').on('click', function () {
        $(this).hide();
        const youtubeVideo = $(this).siblings('iframe[src*=youtube]').get(0);
        if (youtubeVideo) {
            youtubeVideo.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }
        const vimeoVideo = $(this).siblings('iframe[src*=vimeo]').get(0);
        if (vimeoVideo) {
            vimeoVideo.contentWindow.postMessage('{"method":"play"}', '*');
        }
    });
});

initVideos();

// Custom video player
function customVideoPlayer() {
    const videoPlayerContainer = $('.custom-video-player');
    let currentlyPlayingVideo = null;
    if (videoPlayerContainer.length > 0) {
        $(videoPlayerContainer).each(function (id, element) {
            const video = $('video', element)[0];
            const videoPlayer = $(element);
            const playPauseBtn = $('.play-pause-btn', element);
            const volumeButtons = $('.volume-buttons', element);
            const volumeRange = $('.volume-range', element);
            const progressBar = $('.progress-bar', element)[0];
            const progressCircle = $('.progress-circle', element);
            const currentTimeDisplay = $('.current-time-display', element);
            const totalTimeDisplay = $('.total-time-display', element);
            const fullscreenBtn = $('.fullscreen-button', element);
            const closeCaptionBtn = $('.cc-button', element);
            const captionsContainer = $('.captions-container', element);
            const btnCloseVideo = $('.modal-close', element);
            const hideControlsDelay = 750;

            let controlsTimeout;
            let lastInteractionTime = new Date().getTime();
            let isDragging = false;

            function hideControlsAfterDelay() {
                const currentTime = new Date().getTime();
                if (currentTime - lastInteractionTime >= hideControlsDelay) {
                    videoPlayer.addClass('no-controls');
                }
            }

            function toggleFullscreen() {
                if (video.requestFullscreen) {
                    video.requestFullscreen();
                } else if (video.mozRequestFullScreen) {
                    video.mozRequestFullScreen();
                } else if (video.webkitRequestFullscreen) {
                    video.webkitRequestFullscreen();
                } else if (video.msRequestFullscreen) {
                    video.msRequestFullscreen();
                }
            }

            video.addEventListener('ended', function () {
                videoPlayerContainer.parent().removeClass('playing');
                videoPlayer.removeClass('playing');
                captionsContainer.addClass('no-controls');
                if ($('html').hasClass('modal-is-open')) {
                    const modalId = videoPlayer.closest('.modal-video-player').attr('id');
                    MicroModal.close(modalId);
                    $('html').removeClass('modal-is-open');
                }
            });

            document.addEventListener('keydown', function(event) {
                // 32 is the space bar keyCode
                if (event.keyCode === 32 && currentlyPlayingVideo !== null) {
                    if (currentlyPlayingVideo.paused) {
                        currentlyPlayingVideo.play();
                    } else {
                        currentlyPlayingVideo.pause();
                    }
                }
            });

            video.addEventListener('click', function() {
                if (document.fullscreenEnabled && document.fullscreenElement !== null) return;
                if (video.paused) {
                    video.play();
                } else {
                    video.pause();
                }
            });

            btnCloseVideo.on('click', function () {
                video.pause();
                currentlyPlayingVideo = null;
            });

            video.addEventListener('dblclick', toggleFullscreen);

            volumeRange.on('input', function() {
                video.volume = parseFloat(volumeRange.val());
                if (video.volume === 0) {
                    volumeButtons.addClass('muted');
                } else {
                    volumeButtons.removeClass('muted');
                }
            });

            let previousVolumeValue = 0;
            volumeButtons.on('click', function() {
                if (video.volume === 0) {
                    video.volume = previousVolumeValue;
                    volumeButtons.removeClass('muted');
                } else {
                    previousVolumeValue = video.volume;
                    video.volume = 0;
                    volumeButtons.addClass('muted');
                }
                volumeRange.val(video.volume);
            });

            video.addEventListener('play', function() {
                currentlyPlayingVideo = video;
                video.textTracks[0].mode = 'hidden';
                videoPlayer.addClass('playing');
                playPauseBtn.addClass('playing');
                playPauseBtn.removeClass('paused');

                $(document).on('mousemove keydown', function() {
                    videoPlayer.removeClass('no-controls');

                    lastInteractionTime = new Date().getTime();
                    clearTimeout(controlsTimeout);
                    controlsTimeout = setTimeout(hideControlsAfterDelay, hideControlsDelay);
                });

                // Initial hide controls timeout
                controlsTimeout = setTimeout(hideControlsAfterDelay, hideControlsDelay);
            });

            video.addEventListener('pause', function() {
                playPauseBtn.addClass('paused');
                playPauseBtn.removeClass('playing');
            });

            closeCaptionBtn.on('click', function () {
                $(this).toggleClass('active');
                captionsContainer.toggleClass('hidden');
            });

            playPauseBtn.click(function () {
                if (video.paused) {
                    video.play();
                } else {
                    video.pause();
                }
            });

            fullscreenBtn.click(function() {
                toggleFullscreen();
                return false;
            });

            video.addEventListener('fullscreenchange', function() {
                if (document.fullscreen) {
                    if ($(captionsContainer).is(':visible')) {
                        video.textTracks[0].mode = 'showing';
                    }
                } else {
                    video.textTracks[0].mode = 'hidden';
                }
            });

            video.addEventListener('timeupdate', function() {
                const { currentTime, duration } = video;
                const progress = Math.floor((currentTime / duration) * 100);
                progressBar.value = progress;
                progressCircle.css('left', `${progress}%`);

                const minutes = Math.floor(currentTime / 60);
                const seconds = Math.floor(currentTime % 60);
                const formattedTime = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
                currentTimeDisplay.text(formattedTime);

                if (video.textTracks) {
                    for (let i = 0; i < video.textTracks.length; i += 1) {
                        const track = video.textTracks[i];
                        const { activeCues } = track;
                        captionsContainer.empty();

                        if (activeCues && activeCues.length > 0 && track.kind === 'subtitles') {
                            const currentCue = activeCues[0];
                            captionsContainer.text(currentCue.text);
                        }
                    }
                }
            });

            video.addEventListener('loadedmetadata', function() {
                const totalDuration = video.duration;
                const totalMinutes = Math.floor(totalDuration / 60);
                const totalSeconds = Math.floor(totalDuration % 60);
                const formattedTotalTime = `${totalMinutes}:${totalSeconds < 10 ? '0' : ''}${totalSeconds}`;
                totalTimeDisplay.text(formattedTotalTime);
            });

            progressBar.addEventListener('click', function(event) {
                const rect = progressBar.getBoundingClientRect();
                const clickPosition = (event.clientX - rect.left) / rect.width;
                const seekTime = clickPosition * video.duration;
                video.currentTime = seekTime;
            });

            progressBar.addEventListener('input', function() {
                const seekTime = (progressBar.value / 100) * video.duration;
                video.currentTime = seekTime;
            });

            progressCircle.on('mousedown', function() {
                isDragging = true;
            });

            $(document).on('mouseup', function() {
                if (isDragging) {
                    isDragging = false;
                    const seekPosition = parseFloat(progressCircle.css('left')) / progressBar.offsetWidth;
                    const seekTime = seekPosition * video.duration;
                    video.currentTime = seekTime;
                }
            });

            progressBar.addEventListener('mousemove', function(event) {
                if (isDragging) {
                    const rect = progressBar.getBoundingClientRect();
                    const seekPosition = (event.clientX - rect.left) / rect.width;
                    const seekTime = seekPosition * video.duration;
                    video.currentTime = seekTime;
                }
            });
        });
    }
}

// Full with videos
function fullWidthVideos() {
    const fullWidthVideo = $('.block-fullwidth-video');
    if (fullWidthVideo.length > 0) {
        $(fullWidthVideo).each(function (id, element) {
            const videoPlayer = $('.custom-video-player', element);
            const video = $('.custom-video-player video', element)[0];
            const introPlayBtn = $('.play-button', element);

            introPlayBtn.on('click', function () {
                fullWidthVideo.addClass('playing');
                videoPlayer.addClass('playing');
                video.play();
            });
        });
    }
}

customVideoPlayer();
fullWidthVideos();
